module.exports = __webpack_public_path__ + "static/img/7.df39c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/7.png
// module id = erYx
// module chunks = 3